var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 -2)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16C7.464 16 4.001 11.74 4.001 10C4.001 7.999 7.46 4 12.001 4C16.377 4 19.999 7.973 19.999 10C19.999 11.74 16.537 16 12.001 16H12ZM12.001 2C6.48 2 2 6.841 2 10C2 13.086 6.576 18 12 18C17.423 18 22 13.086 22 10C22 6.841 17.52 2 12 2",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.977 11.984C10.874 11.984 9.977 11.087 9.977 9.984C9.977 8.881 10.874 7.984 11.977 7.984C13.081 7.984 13.977 8.881 13.977 9.984C13.977 11.087 13.081 11.984 11.977 11.984ZM11.977 5.984C9.771 5.984 7.977 7.778 7.977 9.984C7.977 12.19 9.771 13.984 11.977 13.984C14.184 13.984 15.977 12.19 15.977 9.984C15.977 7.778 14.184 5.984 11.977 5.984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.c21462567d02c48833c73cdc93b27a47.svg";
export { ForwardRef as ReactComponent };